var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.tags.length,
          expression: "tags.length",
        },
      ],
      staticClass: "i-tag-list",
    },
    _vm._l(_vm.tags, function (tag) {
      return _c(
        "span",
        {
          key: tag,
          staticClass: "tag",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.onClick(tag)
            },
          },
        },
        [_vm._v(_vm._s(tag))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }